import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Validators, EmailValidator, FormBuilder, FormGroup, FormControl } from '@angular/forms';
import { Credentials } from '@bt/core';
import { TokenError } from '../change-password.interfaces';
import 'rxjs/add/operator/filter';
import { PasswordConfirmModel } from '@bt/core/models/passwordConfirm.model';
import { ValidationModel } from '@bt/core/models/validation.model';
import { NotifierService } from 'angular-notifier';
@Component({
    selector: 'change-password-form',
    styleUrls: ["./component.scss"],
    templateUrl: './component.html'
})
export class ChangePasswordFormComponent implements OnInit {
    @Input() public error: TokenError;
    @Input() public showLoader: boolean;
    @Output() public onPasswordChange = new EventEmitter<PasswordConfirmModel>();
    @Output() public onClearError = new EventEmitter();

    public changePasswordForm: FormGroup;
    public isSubmitted: boolean = false;
    public min6symbol:boolean = false;
    public Status: boolean = false; 
    private notifier: NotifierService;
    public passwordModel:any;
    public passwordConfModel : any;
    
    constructor(private fb: FormBuilder,
        notifierService: NotifierService) { 
        this.notifier = notifierService;
    }

    public ngOnInit() {
        this.changePasswordForm = this.fb.group({
            newPassword: new FormControl(null, Validators.required),
            newPasswordConfirmation: new FormControl(null, [Validators.required])
            
        
        });
        // this.notifier.notify(type, message);
        this.changePasswordForm.valueChanges
            .filter(() => !!this.error)
            .forEach(() => {
                this.clearError();
            });
    }

    get newPassword() { return this.changePasswordForm.get('newPassword'); }
    get newPasswordConfirmation() { return this.changePasswordForm.get('newPasswordConfirmation'); }

    public isPasswordsEqual(): boolean {
        if(this.newPassword.value != this.newPasswordConfirmation.value)
            return false;
        return true;
    }

    public change() {

        this.Status = true; 

        this.isSubmitted = true;
       
       var validResult = this.Validate();
       var validConfirmResult = this.ValidatePassword();

       if(!validResult.isValid){
          this.notifier.notify('error',validResult.error);
          return;
       }

       if(!validConfirmResult.isValid){
        this.notifier.notify('error',validConfirmResult.error);
        return;
     }
        
        const passwordConfModel: PasswordConfirmModel = this.changePasswordForm.value;
        this.onPasswordChange.emit(passwordConfModel);


    }


    public Validate(){

        var test = '' + (<any>this.newPassword)._pendingValue;
        var length = test.length;    

        var result = new ValidationModel();
        result.isValid = true;

        if (this.newPassword.errors && this.newPassword.errors.required && (this.newPassword.dirty || this.isSubmitted)){
            result.isValid = false;
            result.error = "Необходимо ввести пароль";
        }
      
        else if (length < 6  ) {
            result.isValid = false;
            result.error = "Длина пароля должна превышать 5 символов";
        }  

        return result;
    }

    public ValidatePassword(){
        var result = new ValidationModel();
        result.isValid = true;

        var test1 = '' + (<any>this.newPasswordConfirmation)._pendingValue;
        var length1 = test1.length;

       
        if (this.newPasswordConfirmation.errors && this.newPasswordConfirmation.errors.required  && (this.newPasswordConfirmation.dirty || this.isSubmitted)){
            result.isValid = false;
            result.error = "Подтверждение пароля обязательно для заполнения";
        }

        else if(!this.isPasswordsEqual() && (this.newPasswordConfirmation.dirty || this.isSubmitted)){
            result.isValid = false;
            result.error = "Подтверждение не соответствует введенному паролю";
        }
      
        else if (length1 < 6  ) {
            result.isValid = false;
            result.error = "Длина пароля должна превышать 5 символов";
        }     

        return result;
    }

    private clearError() {
        this.onClearError.emit();
    }

}



// WEBPACK FOOTER //
// ./src/app/public/change-password/form/component.ts